// 選單 頁面連結
import { useDispatch, useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { setShowComingModal } from '@/slices/popSlice';
import { NAV_MENU } from '@/common/constant';
import Link from 'next/link';
import Image from 'next/image';

const MenuPage = ({ t, showMenu, onClose }) => {
    const dispatch = useDispatch();
    const { web1Url } = useSelector(urlState);

    // 共同內容
    const renderInner = (v) => (
        <>
            <Image
                width={24}
                height={24}
                src={`/images/icon/icon_${v.toLowerCase()}.svg`}
                alt="icon"
                className="pointer-events-none"
            />
            <p
                className={`pointer-events-none [&>*]:trans ${
                    showMenu ? 'w-[110px]' : ''
                } ulg:!w-[110px] whitespace-nowrap`}
            >
                <span
                    className={`text-white ${showMenu ? 'text-btn1' : 'text-bd3n'} ulg:!text-btn1`}
                >
                    {t(v)}
                </span>

                <span
                    className={`text-bou text-bd3n ${showMenu ? '' : 'hidden'} ulg:!inline-block`}
                >
                    &nbsp;{v === 'PORN' ? 'H-GIRL' : v}
                </span>
            </p>
        </>
    );

    // 顯示功能開放彈窗
    const onShowComingModal = (modal) => {
        onClose();
        dispatch(setShowComingModal(modal));
    };

    return (
        <nav
            className={`my-[30px] ${
                showMenu ? 'space-y-[10px]' : ''
            } ulg:!space-y-[10px] ulg:my-[24px]`}
        >
            {Object.keys(NAV_MENU).map((v, i) => {
                // 首頁
                if (v === 'PORN')
                    return (
                        <div
                            key={i + v}
                            className={`rounded-[4px] trans hover:bg-black9 ${
                                showMenu ? 'group' : ''
                            }`}
                        >
                            <Link
                                href="/"
                                className={`gtm-menu-link-hgirl flex gap-x-[10px] trans group-hover:translate-x-[10px] items-center ulg:justify-start
                                ${
                                    showMenu
                                        ? 'px-[12px] py-[10px]'
                                        : 'px-[5px] py-[12px] flex-col justify-center'
                                } ulg:!px-[12px] ulg:!py-[10px] ulg:!flex-row`}
                            >
                                {renderInner(v)}
                            </Link>
                        </div>
                    );

                // 一站
                if (v === 'NORMAL')
                    return (
                        <div
                            rel="noreferrer noopener"
                            key={i + v}
                            className={`rounded-[4px] trans hover:bg-black9 ${
                                showMenu ? 'group' : ''
                            }`}
                        >
                            <a
                                href={web1Url}
                                target="_blank"
                                className={`gtm-menu-link-${v.toLowerCase()} flex gap-x-[10px] trans group-hover:translate-x-[10px] items-center ulg:justify-start
                            ${
                                showMenu
                                    ? 'px-[12px] py-[10px]'
                                    : 'px-[5px] py-[12px] flex-col justify-center'
                            } ulg:!px-[12px] ulg:!py-[10px] ulg:!flex-row`}
                            >
                                {renderInner(v)}
                            </a>
                        </div>
                    );

                return (
                    <div
                        key={i + v}
                        className={`rounded-[4px] trans hover:bg-black9 ${
                            showMenu ? 'group' : ''
                        } cp`}
                        onClick={() => onShowComingModal(v)}
                    >
                        <div
                            className={`gtm-menu-link-${v.toLowerCase()} flex gap-x-[10px] trans group-hover:translate-x-[10px] items-center ulg:justify-start
                                ${
                                    showMenu
                                        ? 'px-[12px] py-[10px]'
                                        : 'px-[5px] py-[12px] flex-col justify-center'
                                } ulg:!px-[12px] ulg:!py-[10px] ulg:!flex-row`}
                        >
                            {renderInner(v)}
                        </div>
                    </div>
                );
            })}
        </nav>
    );
};

export default MenuPage;
